import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Linkedin, Instagram, Youtube, MapPin, Mail, Phone } from "lucide-react";

const LOGO_URL =
  "/assets/logo-abidjan.png";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="navy-pattern relative overflow-hidden text-white pt-16 md:pt-24">
      <div className="absolute -top-10 -right-10 ecl-wordmark">ECL</div>

      <div className="container-edge relative z-10">
        <div className="grid grid-cols-2 md:grid-cols-12 gap-8 md:gap-10 pb-12 md:pb-16">
          <div className="col-span-2 md:col-span-4">
            <img src={LOGO_URL} alt="ECL" className="h-14 w-14 md:h-16 md:w-16 object-contain mb-4 md:mb-5" />
            <div className="font-display text-lg md:text-xl mb-2">École de Commerce de Lyon</div>
            <div className="overline mb-4 md:mb-5" style={{ color: "#ED2939" }}>Campus Abidjan</div>
            <p className="text-white/65 text-sm leading-relaxed max-w-sm">
              La branche abidjanaise de l'ECL.<br />
              L'excellence française au cœur de l'Afrique.
            </p>
          </div>

          <div className="md:col-span-2">
            <div className="overline mb-4" style={{ color: "#ED2939" }}>L'École</div>
            <ul className="space-y-2.5 text-sm text-white/75">
              <li><Link to="/ecole" className="hover:text-white transition-colors">Notre histoire</Link></li>
              <li><Link to="/pourquoi-nous" className="hover:text-white transition-colors">Pourquoi nous</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="overline mb-4" style={{ color: "#ED2939" }}>Formations</div>
            <ul className="space-y-2.5 text-sm text-white/75">
              <li><Link to="/formations" className="hover:text-white transition-colors">Bachelor en Management</Link></li>
              <li><Link to="/formations" className="hover:text-white transition-colors">Master Management & Strategy</Link></li>
              <li><Link to="/formations" className="hover:text-white transition-colors">Master Entrepreneuriat</Link></li>
              <li><Link to="/formations" className="hover:text-white transition-colors">Executive MBA</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="overline mb-4" style={{ color: "#ED2939" }}>Contact</div>
            <ul className="space-y-3 text-sm text-white/75">
              <li className="flex gap-2.5"><MapPin className="h-4 w-4 text-red-500 mt-0.5 shrink-0" />Abidjan, Côte d'Ivoire</li>
              <li className="flex gap-2.5"><Phone className="h-4 w-4 text-red-500 mt-0.5 shrink-0" />+225 01 04 41 94 06</li>
              <li className="flex gap-2.5"><Mail className="h-4 w-4 text-red-500 mt-0.5 shrink-0" />contact@ecoledecommercedelyon.ci</li>
            </ul>
            <div className="flex gap-3 mt-5">
              {[
                { icon: Facebook, label: "Facebook", href: "#" },
                { icon: Linkedin, label: "LinkedIn", href: "#" },
                { icon: Instagram, label: "Instagram", href: "#" },
                { icon: Youtube, label: "YouTube", href: "#" },
              ].map((s) => {
                const Icon = s.icon;
                return (
                  <a
                    key={s.label}
                    href={s.href}
                    aria-label={s.label}
                    data-testid={`social-${s.label.toLowerCase()}`}
                    className="h-9 w-9 flex items-center justify-center border border-white/20 text-white/70 hover:border-white hover:text-white transition-colors"
                  >
                    <Icon className="h-4 w-4" />
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 py-6 flex flex-col md:flex-row gap-3 justify-between items-center text-xs text-white/50">
          <div>
            © {new Date().getFullYear()} École de Commerce de Lyon — Campus Abidjan. Tous droits réservés.
          </div>
          <div className="flex gap-6">
            <Link to="/mentions-legales" data-testid="footer-link-mentions-legales" className="hover:text-white transition-colors">Mentions légales</Link>
            <Link to="/politique-de-confidentialite" data-testid="footer-link-politique-confidentialite" className="hover:text-white transition-colors">Politique de confidentialité</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
